/**
 * Predictive /search/suggest.json no longer matches a bare SKU query.
 * Shopify search syntax `variants.sku:{sku}` still resolves the product.
 * Then confirm exact variants.sku on /products/{handle}.js.
 * See: resources/js/pages/product/linked-products.js
 */
const fetchProductBySku = async (sku) => {
  const queriedSku = String(sku ?? '').trim();

  if (!queriedSku) return null;

  const searchUrl = new URL('/search/suggest.json', window.location.origin);
  searchUrl.searchParams.set('q', `variants.sku:${queriedSku}`);
  searchUrl.searchParams.set('resources[type]', 'product');
  searchUrl.searchParams.set('resources[options][fields]', 'variants.sku');

  const searchResponse = await fetch(searchUrl);

  if (!searchResponse.ok) return null;

  const searchData = await searchResponse.json();
  const results = searchData.resources?.results?.products ?? [];

  const matches = await Promise.all(
    results.map(async (product) => {
      try {
        const productResponse = await fetch(
          new URL(`/products/${product.handle}.js`, window.location.origin),
        );

        if (!productResponse.ok) return null;

        const productData = await productResponse.json();
        const hasSku = (productData.variants || []).some(
          (variant) => variant.sku === queriedSku,
        );

        if (!hasSku) return null;

        return {
          ...product,
          variants: productData.variants,
        };
      } catch {
        return null;
      }
    }),
  );

  return matches.find(Boolean) ?? null;
};

export default fetchProductBySku;
